export const testDriveSending = {
    sendModel(params) {
        let url = `/api/form/${params.brandId}/testdrive/catalog/send_model?model=${params.modelId}`;
        if (params.dealerId) {
            url=`${url}&dealer=${params.dealerId}`
        }
        return url;
    },

    sendTimeSlot(params) {
        const url = `/api/form/${params.brandId}/testdrive/time_slots/${params.timeSlotId}`;
        return url;
    },

    sendClientInfo(params) {
        const url = `/api/form/${params.brandId}/testdrive/contact`;
        return url;
    },

    confirm(params) {
        const url = `/api/form/${params.brandId}/testdrive/confirm`;
        return url;
    }
};



// WEBPACK FOOTER //
// ./src/urlConstructor/testDriveSending.js